import React, {FunctionComponent, FormEvent, useState, createRef,} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {
  Grid,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  IconButton
} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {AppDispatch, RootState} from '../../../store/store';
import {password,} from './set-new-password';
import {Visibility, VisibilityOff,} from '@mui/icons-material';
import {LoadingButton} from '@mui/lab';
import PasswordPolicy from '../../../components/PasswordPolicy/PasswordPolicy';
import useValidator from '../../../helpers/hooks/use-validator';
import {feedback} from "../../../components/Feedback/feedback";

interface Props {
}

const SetNewPassword: FunctionComponent<Props> = (props) => {

  const {t} = useTranslation(['settings']);
  const [modified, setModified] = useState(false);

  const dispatch = useDispatch<AppDispatch>();

  const loading = useSelector((state: RootState) => state.pages.settings.setNewPassword.loading);

  const oldPasswordRef = createRef<HTMLInputElement>();
  const newPasswordRef = createRef<HTMLInputElement>();
  const repeatPasswordRef = createRef<HTMLInputElement>();

  useValidator( [ oldPasswordRef, newPasswordRef,  ] )
    .required()
    .passwordPolicy();

  const onPasswordChange = () => {
    setModified(true);
  }

  const onSetNewPassword = (event: FormEvent) => {

    event.preventDefault();

    const target = event.target as HTMLFormElement;
    const {oldPassword, newPassword, repeatPassword} = Object.fromEntries(new FormData(target));

    // if( oldPassword !== newPassword ) {
    // //   setError( true );
    //   return dispatch( feedback( { message: t( 'Old and new password do not match.' ), severity: 'error' }) )
    // }

    if( newPassword !== repeatPassword ) {
      return dispatch( feedback( {message: t( 'passwords-do-not-match' ) } ) )
    }

    dispatch(password({
      oldPassword: oldPassword as string,
      newPassword: newPassword as string,
    }))
  }

  const [showOldPassword, setShowOldPassword] = useState(false);
  const handleClickShowOldPassword = () => setShowOldPassword(!showOldPassword);

  const [showNewPassword, setShowNewPassword] = useState(false);
  const handleClickShowNewPassword = () => setShowNewPassword(!showNewPassword);

  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const handleClickShowRepeatPassword = () => setShowRepeatPassword(!showRepeatPassword );

  return (
    <Card sx={{mt: 4}}>
      <CardContent>
        <h2>{ t( 'set-new-password' ) }</h2>
        <form onSubmit={ onSetNewPassword }>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6}>
              <TextField
                type={showOldPassword ? "text" : "password"}
                onChange={ onPasswordChange }
                label={ t( 'old-password' ) }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowOldPassword}
                      >
                        {showOldPassword ? <Visibility/> : <VisibilityOff/>}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                inputRef={ oldPasswordRef }
                name="oldPassword"
                variant='standard'
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                type={showNewPassword ? "text" : "password"}
                onChange={ onPasswordChange }
                label={ t( 'new-password' ) }
                inputRef={ newPasswordRef }
                name="newPassword"
                variant='standard'
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowNewPassword}
                      >
                        {showNewPassword ? <Visibility/> : <VisibilityOff/>}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                  type={showRepeatPassword ? "text" : "password"}
                  onChange={ onPasswordChange }
                  label={ t( 'repeat-password' ) }
                  inputRef={ repeatPasswordRef }
                  name="repeatPassword"
                  variant='standard'
                  fullWidth
                  InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                              onClick={handleClickShowRepeatPassword}
                          >
                            {showRepeatPassword ? <Visibility/> : <VisibilityOff/>}
                          </IconButton>
                        </InputAdornment>
                    )
                  }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <PasswordPolicy/>
            </Grid>
            <Grid item xs={12} sm={12} style={{ display: 'flex'}}>
              <Grid container justifyContent='flex-end' alignContent={'end'}>
                <LoadingButton
                  disabled={!modified}
                  loading={loading === 'pending'}
                  variant='contained'
                  type="submit"
                >{ t( 'save' ) }</LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
}

export default SetNewPassword;
